import ApiError from 'utils/api/errors/ApiError';


class ApiInternalServerError extends ApiError {
  constructor (props) {
    super(props);
    this.name = 'ApiInternalServerError';
  }
}

export default ApiInternalServerError;
